import React, { useState, useEffect, useRef } from 'react';
import { ReactComponent as VinificacionIcon } from '../../assets/icons/VinificacionIcon.svg';
import { Listbox, ListboxButton, ListboxOptions, ListboxOption,  Combobox, ComboboxButton, ComboboxInput, ComboboxOptions, ComboboxOption } from '@headlessui/react';
import { getAuth } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { invalidarCacheColecciones } from '../../services/dataCache';
import FechaDateInput from '../FechaDateInput';
const estadoInicial = {
pertenencia: '',
tipo_uso: '',
hectolitros: '',
quintales_consumidos: '',
nombre_bodega: '',
vinificacion: {
fermentacion_primaria: {
inicio: '',
fin: '',
temperatura: '',
humedad: '',
graduacion_alcoholica: '',
nivel_acidez: '',
nivel_azucar: '',
nivel_ph: '',
recipiente_utilizado: '',
recipiente_uso: '',
recipiente_tostado: ''
},
fermentacion_secundaria: {
inicio: '',
fin: '',
temperatura: '',
humedad: '',
graduacion_alcoholica: '',
nivel_acidez: '',
nivel_azucar: '',
nivel_ph: '',
recipiente_utilizado: '',
recipiente_uso: '',
recipiente_tostado: ''
},
tranquilizacion: {
inicio: '',
fin: '',
temperatura: '',
humedad: '',
graduacion_alcoholica: '',
nivel_acidez: '',
nivel_azucar: '',
nivel_ph: '',
recipiente_utilizado: '',
recipiente_uso: '',
recipiente_tostado: ''
},
guarda: {
inicio: '',
fin: '',
temperatura: '',
humedad: '',
graduacion_alcoholica: '',
nivel_acidez: '',
nivel_azucar: '',
nivel_ph: '',
recipiente_utilizado: '',
recipiente_uso: '',
recipiente_tostado: ''
},
tipo_levadura: '',
},
profesional_responsable: '',
lote_id: ''
};
const opcionesRecipienteUso = ['Primero', 'Segundo', 'Tercero'];
const opcionesRecipienteTostado = ['Suave', 'Medio', 'Fuerte'];
const tiposDeRecipienteFermentacion = [
'Acero Inoxidable',
'Ánforas de barro',
'Barrica de Roble Americano',
'Barrica de Roble Francés',
'Barrica otro',
'Epoxi',
'Fudres',
'Hormigón',
'Huevos de Hormigón'
];
const levaduraOptions = {
'Fermentación Nativa': 'Fermentación Nativa',
'No-Saccharomyces': [
'Brettanomyces bruxellensis',
'Hanseniaspora uvarum',
'Kloeckera apiculata',
'Lachancea thermotolerans',
'Metschnikowia pulcherrima',
'Pichia kluyveri',
'Starmerella bacillaris',
'Torulaspora delbrueckii',
],
'Saccharomyces': [
'Saccharomyces bayanus',
'Saccharomyces cerevisiae',
'Saccharomyces pastorianus',
'Saccharomyces uvarum',
],
};
const opcionesTipoUso = ['Propio', 'Marca Blanca'];
// El dato se guarda siempre en hectolitros; estas unidades son solo para mostrar/cargar.
const unidadesVolumen = ['Hectolitros', 'Litros'];
const abreviaturasVolumen = { Hectolitros: 'hl', Litros: 'lts' };

const VinificacionForm = () => {
const navigate = useNavigate();
const [formData, setFormData] = useState(estadoInicial);
const [unidadVolumen, setUnidadVolumen] = useState('Hectolitros');
const [lotes, setLotes] = useState([]);
const [message, setMessage] = useState(null);
const [isLoading, setIsLoading] = useState(false);
const [otroRecipiente, setOtroRecipiente] = useState('');
const [progress, setProgress] = useState(0);
const primeraRef = useRef();
const segundaRef = useRef();
const [query, setQuery] = useState(''); 
const filteredLotes =
  query === ''
    ? lotes
    : lotes.filter((lote) => {
        return lote.id.toLowerCase().includes(query.toLowerCase());
      });

// Quintales disponibles del lote seleccionado (fallback a 'quintales' para lotes viejos).
const loteSeleccionado = lotes.find((l) => l.id === formData.lote_id);
const quintalesDisponibles = loteSeleccionado
  ? (loteSeleccionado.quintales_presentes ?? loteSeleccionado.quintales ?? 0)
  : null;

useEffect(() => {
const handleScroll = () => {
const primeraTop = primeraRef.current.getBoundingClientRect().top;
const segundaTop = segundaRef.current.getBoundingClientRect().top;

};

window.addEventListener('scroll', handleScroll);
return () => window.removeEventListener('scroll', handleScroll);
}, []);
useEffect(() => {
const fetchLotes = async () => {
try {
const response = await fetch('https://backend-288175208699.europe-west1.run.app/api/lotes', {
headers: { Authorization: `Bearer ${await getAuth().currentUser.getIdToken()}` },
});
if (!response.ok) {
throw new Error('No se pudo obtener la lista de lotes.');
}
const data = await response.json();
const lotesFinalizados = data.filter(lote => lote.estado === 'finalizado');
setLotes(lotesFinalizados);
} catch (error) {
console.error("Error al cargar lotes:", error);
setMessage({ type: 'error', text: error.message });
} finally {
}
};
fetchLotes();
}, []);
const handleChange = (valueOrEvent, etapa = null, campo = null) => {
let value, name;
if (valueOrEvent && valueOrEvent.target) {
value = valueOrEvent.target.value;
name = valueOrEvent.target.name;
} else {
value = valueOrEvent;
name = campo;
}
if (!name) return;
setFormData(prev => {
if (etapa && campo) {
return {
...prev,
vinificacion: {
...prev.vinificacion,
[etapa]: {
...prev.vinificacion[etapa],
[campo]: value
}
}
};
}
return {
...prev,
[name]: value
};
});
};
const handleSubmit = async (e) => {
e.preventDefault();
setIsLoading(true);
setProgress(0);
setMessage(null);

const user = getAuth().currentUser;
if (!user) {
setMessage({ type: 'error', text: 'Debes iniciar sesión para crear una partida.' });
setIsLoading(false);
return;
}

try {
const idToken = await user.getIdToken();
const datosParaEnviar = {
...formData,
vinificacion: {
...formData.vinificacion,
tipo_levadura: formData.vinificacion.tipo_levadura
},
};

// Simulamos progreso mientras dura la petición
const interval = setInterval(() => {
setProgress(prev => Math.min(prev + 5, 95));
}, 100);

const response = await fetch('https://backend-288175208699.europe-west1.run.app/api/vinificacion', {
method: 'POST',
headers: {
'Content-Type': 'application/json',
'Authorization': `Bearer ${idToken}`,
},
body: JSON.stringify(datosParaEnviar),
});

clearInterval(interval);
setProgress(100);
const data = await response.json();
if (!response.ok) throw new Error(data.error || 'Ocurrió un error.');

setMessage({ type: 'success', text: data.mensaje });
const match = data.mensaje.match(/ID[:\s]+(\S+)/);
invalidarCacheColecciones();
if (match && match[1]) {
const id = match[1];
setTimeout(() => {
navigate(`/trazabilidad/${id}`);
}, 800);
} else {
setIsLoading(false);
setProgress(0);
}

} catch (error) {
setMessage({ type: 'error', text: error.message });
setIsLoading(false);
setProgress(0);
}
};

const esFormularioValido = () => {
const { lote_id, pertenencia, tipo_uso, hectolitros, quintales_consumidos, vinificacion, nombre_bodega, profesional_responsable } = formData;

if (!lote_id || !pertenencia || !tipo_uso || !hectolitros || !quintales_consumidos || !profesional_responsable) { // <--- AGREGAR tipo_uso AQUÍ
return false;
}

if (pertenencia === 'tercero' && !nombre_bodega) {
return false;
}

// No permitir consumir más quintales de los disponibles en el lote.
if (quintalesDisponibles != null && parseFloat(quintales_consumidos) > quintalesDisponibles) {
return false;
}

const recipiente = vinificacion.fermentacion_primaria.recipiente_utilizado;

if (!recipiente) {
return false;
}

if (recipiente.toLowerCase().startsWith("barrica")) {
if (!vinificacion.fermentacion_primaria.recipiente_uso || !vinificacion.fermentacion_primaria.recipiente_tostado) {
return false;
}
}

return true;
};
// formData.hectolitros siempre queda en hl; estas funciones solo traducen para la unidad elegida.
// El redondeo a 6 decimales es para pisar el ruido de punto flotante de
// valorHl * 100 (ej. 0.07 * 100 = 7.000000000000001 en JS), no para limitar
// la precisión real del dato.
const hlAUnidadMostrada = (valorHl) => {
if (valorHl === null || valorHl === undefined || valorHl === '') return '';
return unidadVolumen === 'Litros' ? Math.round(valorHl * 100 * 1e6) / 1e6 : valorHl;
};
const handleHectolitrosChange = (e) => {
const value = e.target.value;
if (value === '') {
setFormData(prev => ({ ...prev, hectolitros: null }));
return;
}
const numero = parseFloat(value);
if (isNaN(numero)) return;
setFormData(prev => ({ ...prev, hectolitros: unidadVolumen === 'Litros' ? numero / 100 : numero }));
};
const handleNumberChange = (e, etapa = null, campo = null) => {
const value = e.target.value;
setFormData(prev => {
if (etapa && campo) {
return {
...prev,
vinificacion: {
...prev.vinificacion,
[etapa]: {
...prev.vinificacion[etapa],
[campo]: value === '' ? null : parseFloat(value),
}
}
};
}
return {
...prev,
[e.target.name]: value === '' ? null : parseFloat(value),
};
});
};
return (
<div className="container">
<div className="formtitle-container">
<div className="formicon-container">
<VinificacionIcon className="formicon" />
</div>
<h1 className="formtitle">Vinificación</h1>
</div>
<hr className="divider" />
<form onSubmit={handleSubmit} className="form">
<div className="columns-container" >
<div className="column long">
<div className="input-group">
<Listbox
value={formData.pertenencia}
onChange={(value) => handleChange(value, null, 'pertenencia')}
>
{({ open }) => (
<>
<ListboxButton className={`custom-listbox-button ${open ? 'open' : ''} ${
formData.pertenencia ? 'selected' : 'placeholder'}`} >
{formData.pertenencia 
? formData.pertenencia.charAt(0).toUpperCase() + formData.pertenencia.slice(1) 
: "Tipo de propiedad"}
<span className="custom-arrow-container">
<span className="custom-arrow"></span>
</span>
</ListboxButton>
<ListboxOptions className="custom-listbox-options">
<ListboxOption value="propia" className="custom-listbox-option">
Propia
</ListboxOption>
<ListboxOption value="tercero" className="custom-listbox-option">
Tercero
</ListboxOption>
</ListboxOptions>
</>
)}
</Listbox>
</div>
{formData.pertenencia === 'tercero' && (
<div className="input-group">
<input
type="text"
name="nombre_bodega"
value={formData.nombre_bodega}
onChange={handleChange}
className="input"
placeholder="Nombre de la bodega"
required
/>
</div>
)}
      <div className="input-group">
        <Combobox
          value={formData.lote_id}
          onChange={(value) => handleChange(value, null, 'lote_id')}
        >
          {({ open }) => (
            <>
              <ComboboxButton as="div" className={`custom-listbox-button ${open ? 'open' : ''} ${
                formData.lote_id ? 'selected' : 'placeholder'}`} style={{width:'100%',padding:'1px 0'}}>
                <ComboboxInput
                  className="input"
                  displayValue={() => formData.lote_id}
                  onChange={(event) => setQuery(event.target.value)}
                  placeholder="Seleccionar lote..."
                />
                <span className="custom-arrow-container" style={{marginRight:'5px'}}>
                  <span className="custom-arrow"></span>
                </span>
              </ComboboxButton>
              <ComboboxOptions className="custom-listbox-options">
                {filteredLotes.length === 0 && query !== '' ? (
                  <div className="custom-listbox-option empty">No se encontraron lotes.</div>
                ) : (
                  filteredLotes.map((lote) => (
                    <ComboboxOption
                      key={lote.id}
                      value={lote.id}
                      className="custom-listbox-option"
                    >
                      {lote.id}
                    </ComboboxOption>
                  ))
                )}
              </ComboboxOptions>
            </>
          )}
        </Combobox>
      </div>
<div className="input-group number">
<input type="number" name="quintales_consumidos" value={formData.quintales_consumidos ?? ''} onChange={handleNumberChange} className="input" placeholder="Quintales consumidos del lote" max={quintalesDisponibles ?? undefined} required />
<span className="unit">q</span>
</div>
{quintalesDisponibles != null && (
<span className="input-hint" style={{ fontSize: '12px', color: formData.quintales_consumidos && parseFloat(formData.quintales_consumidos) > quintalesDisponibles ? '#c0392b' : '#888', margin: '-6px 0 4px' }}>
Disponible en el lote: {quintalesDisponibles} q
</span>
)}
<div className="input-group number">
<input type="number" name="hectolitros" value={hlAUnidadMostrada(formData.hectolitros)} onChange={handleHectolitrosChange} className="input" placeholder={`Cantidad de ${unidadVolumen === 'Litros' ? 'litros' : 'hectolitros'} obtenidos`} required />
<span className="unit">{abreviaturasVolumen[unidadVolumen]}</span>
</div>
<div className="input-group">
<Listbox value={unidadVolumen} onChange={setUnidadVolumen}>
{({ open }) => (
<>
<ListboxButton className={`custom-listbox-button ${open ? 'open' : ''} selected`}>
{unidadVolumen}
<span className="custom-arrow-container">
<span className="custom-arrow"></span>
</span>
</ListboxButton>
<ListboxOptions className="custom-listbox-options">
{unidadesVolumen.map((opcion) => (
<ListboxOption key={opcion} value={opcion} className="custom-listbox-option">
{opcion}
</ListboxOption>
))}
</ListboxOptions>
</>
)}
</Listbox>
</div>
                        <div className="input-group">
                            <Listbox
                                value={formData.tipo_uso}
                                onChange={(value) => handleChange(value, null, 'tipo_uso')} // <--- Manejador para el nuevo campo
                            >
                                {({ open }) => (
                                    <>
                                        <ListboxButton className={`custom-listbox-button ${open ? 'open' : ''} ${
                                            formData.tipo_uso ? 'selected' : 'placeholder'}`} >
                                            {formData.tipo_uso
                                                ? formData.tipo_uso
                                                : "Tipo de uso"}
                                            <span className="custom-arrow-container">
                                                <span className="custom-arrow"></span>
                                            </span>
                                        </ListboxButton>
                                        <ListboxOptions className="custom-listbox-options">
                                            {opcionesTipoUso.map((opcion) => (
                                                <ListboxOption
                                                    key={opcion}
                                                    value={opcion}
                                                    className="custom-listbox-option"
                                                >
                                                    {opcion}
                                                </ListboxOption>
                                            ))}
                                        </ListboxOptions>
                                    </>
                                )}
                            </Listbox>
                        </div>
<label ref={primeraRef} className="input-label">Primera fermentación</label>
<div className="input-group">
<label className='date-label'>Fecha de inicio</label>
<FechaDateInput name="fermentacion_primaria_inicio" value={formData.vinificacion.fermentacion_primaria.inicio} onChange={(iso) => handleChange(iso, 'fermentacion_primaria', 'inicio')} className="input" placeholder="Inicio Fermentación Primaria"  />
</div>
<div className="input-group number">
<input
type="number"
name="temperatura_controlada"
value={formData.vinificacion.fermentacion_primaria.temperatura}
onChange={(e) => handleNumberChange(e, "fermentacion_primaria", "temperatura")}
className="input"
step="0.1"
placeholder="Temperatura"
/>
<span className="unit">°C</span>
</div>
<div className="input-group number">
<input type="number" name="humedad_controlada" value={formData.vinificacion.fermentacion_primaria.humedad}onChange={(e) => handleNumberChange(e, "fermentacion_primaria", "humedad")} className="input" placeholder="Humedad"  />
<span className="unit">%</span></div>
<div className="input-group">
<Listbox
value={formData.vinificacion.tipo_levadura}
onChange={(value) => setFormData(prev => ({
...prev,
vinificacion: {
...prev.vinificacion,
tipo_levadura: value
}
}))}
>
{({ open }) => (
<>
<ListboxButton className={`custom-listbox-button ${open ? 'open' : ''} ${
formData.vinificacion.tipo_levadura ? 'selected' : 'placeholder'
}`}>
{formData.vinificacion.tipo_levadura || "Tipo de levadura"}
<span className="custom-arrow-container">
<span className="custom-arrow"></span>
</span>
</ListboxButton>
<ListboxOptions className="custom-listbox-options">
<div className="listbox-group-label">Fermentación Nativa</div>
<ListboxOption
value={levaduraOptions['Fermentación Nativa']}
className="custom-listbox-option"
>
{levaduraOptions['Fermentación Nativa']}
</ListboxOption>
<div className="listbox-group-label">Levaduras Saccharomyces</div>
{levaduraOptions['Saccharomyces'].map((levadura, index) => (
<ListboxOption
key={`sacch-${index}`}
value={levadura}
className="custom-listbox-option"
>
{levadura}
</ListboxOption>
))}
<div className="listbox-group-label">Levaduras No-Saccharomyces</div>
{levaduraOptions['No-Saccharomyces'].map((levadura, index) => (
<ListboxOption
key={`no-sacch-${index}`}
value={levadura}
className="custom-listbox-option"
>
{levadura}
</ListboxOption>
))}
</ListboxOptions>
</>
)}
</Listbox>
</div>
<div className="input-group number">
<input type="number" name="graduacion_alcoholica" value={formData.vinificacion.fermentacion_primaria.graduacion_alcoholica} onChange={(e) => handleNumberChange(e, "fermentacion_primaria", "graduacion_alcoholica")} className="input" step="0.1" placeholder="Graduación alcohólica"  />
<span className="unit">%</span></div>
<div className="input-group number">
<input type="number" name="nivel_acido" value={formData.vinificacion.fermentacion_primaria.nivel_acidez} onChange={(e) => handleNumberChange(e, "fermentacion_primaria", "nivel_acidez")} className="input" step="0.1" placeholder="Nivel de acidéz"  />
<span className="unit">g/L</span></div>
<div className="input-group number">
<input type="number" name="nivel_azucar" value={formData.vinificacion.fermentacion_primaria.nivel_azucar} onChange={(e) => handleNumberChange(e, "fermentacion_primaria", "nivel_azucar")} className="input" step="0.1" placeholder="Nivel de azúcar"  />
<span className="unit">° Brix</span></div>
<div className="input-group number">
<input type="number" name="nivel_ph" value={formData.vinificacion.fermentacion_primaria.nivel_ph} onChange={(e) => handleNumberChange(e, "fermentacion_primaria", "nivel_ph")} className="input" step="0.1" placeholder="Nivel de pH"  />
<span className="unit">pH</span></div>
<div className="input-group">
<Listbox
value={formData.vinificacion.fermentacion_primaria.recipiente_utilizado}
onChange={(value) => {
handleChange(value, 'fermentacion_primaria', 'recipiente_utilizado');
if (value !== 'Barrica otro') setOtroRecipiente(''); // limpiar si cambia a otra opción
}}
>
{({ open }) => (
<>
<ListboxButton
className={`custom-listbox-button ${open ? 'open' : ''} ${
formData.vinificacion.fermentacion_primaria.recipiente_utilizado ? 'selected' : 'placeholder'
}`}
>
{formData.vinificacion.fermentacion_primaria.recipiente_utilizado || "Recipiente utilizado"}
<span className="custom-arrow-container"><span className="custom-arrow"></span></span>
</ListboxButton>
<ListboxOptions className="custom-listbox-options">
{tiposDeRecipienteFermentacion.map((recipiente) => (
<ListboxOption
key={recipiente}
value={recipiente}
className="custom-listbox-option"
>
{recipiente}
</ListboxOption>
))}
</ListboxOptions>
</>
)}
</Listbox>
</div>

{formData.vinificacion.fermentacion_primaria.recipiente_utilizado === "Barrica otro" && (
<div className="input-group">
<input
type="text"
placeholder="Especificar tipo de barrica"
value={otroRecipiente}
onChange={(e) => setOtroRecipiente(e.target.value)}
className="input"
/>
</div>
)}
{formData.vinificacion.fermentacion_primaria.recipiente_utilizado?.toLowerCase().startsWith("barrica") && (
<>
<div className="input-group">
<Listbox
value={formData.vinificacion.fermentacion_primaria.recipiente_uso}
onChange={(value) => handleChange(value, 'fermentacion_primaria', 'recipiente_uso')}
>
{({ open }) => (
<>
<ListboxButton className={`custom-listbox-button ${open ? 'open' : ''} ${formData.vinificacion.fermentacion_primaria.recipiente_uso ? 'selected' : 'placeholder'}`}>
{formData.vinificacion.fermentacion_primaria.recipiente_uso || "Uso del recipiente"}
<span className="custom-arrow-container"><span className="custom-arrow"></span></span>
</ListboxButton>
<ListboxOptions className="custom-listbox-options">
{opcionesRecipienteUso.map((opcion) => (
<ListboxOption key={opcion} value={opcion} className="custom-listbox-option">
{opcion}
</ListboxOption>
))}
</ListboxOptions>
</>
)}
</Listbox>
</div>

<div className="input-group">
<Listbox
value={formData.vinificacion.fermentacion_primaria.recipiente_tostado}
onChange={(value) => handleChange(value, 'fermentacion_primaria', 'recipiente_tostado')}
>
{({ open }) => (
<>
<ListboxButton className={`custom-listbox-button ${open ? 'open' : ''} ${formData.vinificacion.fermentacion_primaria.recipiente_tostado ? 'selected' : 'placeholder'}`}>
{formData.vinificacion.fermentacion_primaria.recipiente_tostado || "Tostado de recipiente"}
<span className="custom-arrow-container"><span className="custom-arrow"></span></span>
</ListboxButton>
<ListboxOptions className="custom-listbox-options">
{opcionesRecipienteTostado.map((opcion) => (
<ListboxOption key={opcion} value={opcion} className="custom-listbox-option">
{opcion}
</ListboxOption>
))}
</ListboxOptions>
</>
)}
</Listbox>
</div>
</>
)}

<div className="input-group">
<label className='date-label'>Fecha de finalización</label>
<FechaDateInput name="fermentacion_primaria_fin" value={formData.vinificacion.fermentacion_primaria.fin} onChange={(iso) => handleChange(iso, 'fermentacion_primaria', 'fin')} className="input" placeholder="Fin Fermentación Primaria"  />
</div>
<label ref={segundaRef} className="input-label">Segunda fermentación</label>
<div className="input-group">
<label className='date-label'>Fecha de inicio</label>
<FechaDateInput name="fermentacion_secundaria_inicio" value={formData.vinificacion.fermentacion_secundaria.inicio} onChange={(iso) => handleChange(iso, 'fermentacion_secundaria', 'inicio')} className="input" placeholder="Inicio Fermentación Primaria"  />
</div>
<div className="input-group number">
<input type="number" name="temperatura_controlada" value={formData.vinificacion.fermentacion_secundaria.temperatura} onChange={(e) => handleNumberChange(e, "fermentacion_secundaria", "temperatura")} className="input" step="0.1" placeholder="Temperatura"  />
<span className="unit">°C</span></div>
<div className="input-group number">
<input type="number" name="humedad_controlada" value={formData.vinificacion.fermentacion_secundaria.humedad} onChange={(e) => handleNumberChange(e, "fermentacion_secundaria", "humedad")} className="input" placeholder="Humedad"  />
<span className="unit">%</span></div>
<div className="input-group number">
<input type="number" name="graduacion_alcoholica" value={formData.vinificacion.fermentacion_secundaria.graduacion_alcoholica}  onChange={(e) => handleNumberChange(e, "fermentacion_secundaria", 'graduacion_alcoholica')} className="input" step="0.1" placeholder="Graduación alcohólica"  />
<span className="unit">%</span></div>
<div className="input-group number">
<input type="number" name="nivel_acido" value={formData.vinificacion.fermentacion_secundaria.nivel_acidez}  onChange={(e) => handleNumberChange(e, "fermentacion_secundaria", 'nivel_acidez')} className="input" step="0.1" placeholder="Nivel de acidéz"  />
<span className="unit">g/L</span></div>
<div className="input-group number">
<input type="number" name="nivel_azucar" value={formData.vinificacion.fermentacion_secundaria.nivel_azucar}  onChange={(e) => handleNumberChange(e, "fermentacion_secundaria", 'nivel_azucar')} className="input" step="0.1" placeholder="Nivel de azúcar"  />
<span className="unit">° Brix</span></div>
<div className="input-group number">
<input type="number" name="nivel_ph" value={formData.vinificacion.fermentacion_secundaria.nivel_ph}  onChange={(e) => handleNumberChange(e, "fermentacion_secundaria", 'nivel_ph')} className="input" step="0.1" placeholder="Nivel de pH"  />
<span className="unit">pH</span></div>
<div className="input-group">
<Listbox
value={formData.vinificacion.fermentacion_secundaria.recipiente_utilizado}
onChange={(value) => {
handleChange(value, 'fermentacion_secundaria', 'recipiente_utilizado');
if (value !== 'Barrica otro') setOtroRecipiente(''); // limpiar si cambia a otra opción
}}
>
{({ open }) => (
<>
<ListboxButton
className={`custom-listbox-button ${open ? 'open' : ''} ${
formData.vinificacion.fermentacion_secundaria.recipiente_utilizado ? 'selected' : 'placeholder'
}`}
>
{formData.vinificacion.fermentacion_secundaria.recipiente_utilizado || "Recipiente utilizado"}
<span className="custom-arrow-container"><span className="custom-arrow"></span></span>
</ListboxButton>
<ListboxOptions className="custom-listbox-options">
{tiposDeRecipienteFermentacion.map((recipiente) => (
<ListboxOption
key={recipiente}
value={recipiente}
className="custom-listbox-option"
>
{recipiente}
</ListboxOption>
))}
</ListboxOptions>
</>
)}
</Listbox>
</div>

{formData.vinificacion.fermentacion_secundaria.recipiente_utilizado === "Barrica otro" && (
<div className="input-group">
<input
type="text"
placeholder="Especificar tipo de barrica"
value={otroRecipiente}
onChange={(e) => setOtroRecipiente(e.target.value)}
className="input"
/>
</div>
)}
{formData.vinificacion.fermentacion_secundaria.recipiente_utilizado?.toLowerCase().startsWith("barrica") && (
<>
<div className="input-group">
<Listbox
value={formData.vinificacion.fermentacion_secundaria.recipiente_uso}
onChange={(value) => handleChange(value, 'fermentacion_secundaria', 'recipiente_uso')}
>
{({ open }) => (
<>
<ListboxButton className={`custom-listbox-button ${open ? 'open' : ''} ${formData.vinificacion.fermentacion_secundaria.recipiente_uso ? 'selected' : 'placeholder'}`}>
{formData.vinificacion.fermentacion_secundaria.recipiente_uso || "Uso del recipiente"}
<span className="custom-arrow-container"><span className="custom-arrow"></span></span>
</ListboxButton>
<ListboxOptions className="custom-listbox-options">
{opcionesRecipienteUso.map((opcion) => (
<ListboxOption key={opcion} value={opcion} className="custom-listbox-option">
{opcion}
</ListboxOption>
))}
</ListboxOptions>
</>
)}
</Listbox>
</div>

<div className="input-group">
<Listbox
value={formData.vinificacion.fermentacion_secundaria.recipiente_tostado}
onChange={(value) => handleChange(value, 'fermentacion_secundaria', 'recipiente_tostado')}
>
{({ open }) => (
<>
<ListboxButton className={`custom-listbox-button ${open ? 'open' : ''} ${formData.vinificacion.fermentacion_secundaria.recipiente_tostado ? 'selected' : 'placeholder'}`}>
{formData.vinificacion.fermentacion_secundaria.recipiente_tostado || "Tostado de recipiente"}
<span className="custom-arrow-container"><span className="custom-arrow"></span></span>
</ListboxButton>
<ListboxOptions className="custom-listbox-options">
{opcionesRecipienteTostado.map((opcion) => (
<ListboxOption key={opcion} value={opcion} className="custom-listbox-option">
{opcion}
</ListboxOption>
))}
</ListboxOptions>
</>
)}
</Listbox>
</div>
</>
)}
<div className="input-group">
<label className='date-label'>Fecha de finalización</label>
<FechaDateInput name="fermentacion_secundaria_fin" value={formData.vinificacion.fermentacion_secundaria.fin} onChange={(iso) => handleChange(iso, 'fermentacion_secundaria', 'fin')} className="input" placeholder="Fin Fermentación Primaria"  />
</div><div className="bottom-gradient"></div>
</div>
<div className="column long">
<label className="input-label sticky-label">Tranquilización y filtrado</label>
<div className="input-group">
<label className='date-label'>Fecha de inicio</label>
<FechaDateInput name="tranquilizacion_inicio" value={formData.vinificacion.tranquilizacion.inicio} onChange={(iso) => handleChange(iso, 'tranquilizacion', 'inicio')} className="input" placeholder="Inicio Fermentación Primaria"  />
</div>
<div className="input-group number">
<input type="number" name="temperatura_controlada" value={formData.vinificacion.tranquilizacion.temperatura} onChange={(e) => handleNumberChange(e, "tranquilizacion", 'temperatura')} className="input" step="0.1" placeholder="Temperatura"  />
<span className="unit">°C</span></div>
<div className="input-group number">
<input type="number" name="humedad_controlada" value={formData.vinificacion.tranquilizacion.humedad} onChange={(e) => handleNumberChange(e, "tranquilizacion", 'humedad')} className="input" placeholder="Humedad"  />
<span className="unit">%</span></div>
<div className="input-group number">
<input type="number" name="graduacion_alcoholica" value={formData.vinificacion.tranquilizacion.graduacion_alcoholica} onChange={(e) => handleNumberChange(e, "tranquilizacion", 'graduacion_alcoholica')} className="input" step="0.1" placeholder="Graduación alcohólica"  />
<span className="unit">%</span></div>
<div className="input-group number">
<input type="number" name="nivel_acido" value={formData.vinificacion.tranquilizacion.nivel_acidez} onChange={(e) => handleNumberChange(e, "tranquilizacion",'nivel_acidez')} className="input" step="0.1" placeholder="Nivel de acidéz"  />
<span className="unit">g/L</span></div>
<div className="input-group number">
<input type="number" name="nivel_azucar" value={formData.vinificacion.tranquilizacion.nivel_azucar} onChange={(e) => handleNumberChange(e, "tranquilizacion", 'nivel_azucar')} className="input" step="0.1" placeholder="Nivel de azúcar"  />
<span className="unit">° Brix</span></div>
<div className="input-group number">
<input type="number" name="nivel_ph" value={formData.vinificacion.tranquilizacion.nivel_ph} onChange={(e) => handleNumberChange(e, "tranquilizacion", 'nivel_ph')} className="input" step="0.1" placeholder="Nivel de pH"  />
<span className="unit">pH</span></div>
<div className="input-group">
<Listbox
value={formData.vinificacion.tranquilizacion.recipiente_utilizado}
onChange={(value) => {
handleChange(value, 'tranquilizacion', 'recipiente_utilizado');
if (value !== 'Barrica otro') setOtroRecipiente(''); // limpiar si cambia a otra opción
}}
>
{({ open }) => (
<>
<ListboxButton
className={`custom-listbox-button ${open ? 'open' : ''} ${
formData.vinificacion.tranquilizacion.recipiente_utilizado ? 'selected' : 'placeholder'
}`}
>
{formData.vinificacion.tranquilizacion.recipiente_utilizado || "Recipiente utilizado"}
<span className="custom-arrow-container"><span className="custom-arrow"></span></span>
</ListboxButton>
<ListboxOptions className="custom-listbox-options">
{tiposDeRecipienteFermentacion.map((recipiente) => (
<ListboxOption
key={recipiente}
value={recipiente}
className="custom-listbox-option"
>
{recipiente}
</ListboxOption>
))}
</ListboxOptions>
</>
)}
</Listbox>
</div>

{formData.vinificacion.tranquilizacion.recipiente_utilizado === "Barrica otro" && (
<div className="input-group">
<input
type="text"
placeholder="Especificar tipo de barrica"
value={otroRecipiente}
onChange={(e) => setOtroRecipiente(e.target.value)}
className="input"
/>
</div>
)}
{formData.vinificacion.tranquilizacion.recipiente_utilizado?.toLowerCase().startsWith("barrica") && (
<>
<div className="input-group">
<Listbox
value={formData.vinificacion.tranquilizacion.recipiente_uso}
onChange={(value) => handleChange(value, 'tranquilizacion', 'recipiente_uso')}
>
{({ open }) => (
<>
<ListboxButton className={`custom-listbox-button ${open ? 'open' : ''} ${formData.vinificacion.tranquilizacion.recipiente_uso ? 'selected' : 'placeholder'}`}>
{formData.vinificacion.tranquilizacion.recipiente_uso || "Uso del recipiente"}
<span className="custom-arrow-container"><span className="custom-arrow"></span></span>
</ListboxButton>
<ListboxOptions className="custom-listbox-options">
{opcionesRecipienteUso.map((opcion) => (
<ListboxOption key={opcion} value={opcion} className="custom-listbox-option">
{opcion}
</ListboxOption>
))}
</ListboxOptions>
</>
)}
</Listbox>
</div>

<div className="input-group">
<Listbox
value={formData.vinificacion.tranquilizacion.recipiente_tostado}
onChange={(value) => handleChange(value, 'tranquilizacion', 'recipiente_tostado')}
>
{({ open }) => (
<>
<ListboxButton className={`custom-listbox-button ${open ? 'open' : ''} ${formData.vinificacion.tranquilizacion.recipiente_tostado ? 'selected' : 'placeholder'}`}>
{formData.vinificacion.tranquilizacion.recipiente_tostado || "Tostado de recipiente"}
<span className="custom-arrow-container"><span className="custom-arrow"></span></span>
</ListboxButton>
<ListboxOptions className="custom-listbox-options">
{opcionesRecipienteTostado.map((opcion) => (
<ListboxOption key={opcion} value={opcion} className="custom-listbox-option">
{opcion}
</ListboxOption>
))}
</ListboxOptions>
</>
)}
</Listbox>
</div>
</>
)}
<div className="input-group">
<label className='date-label'>Fecha de finalización</label>
<FechaDateInput name="tranquilizacion_fin" value={formData.vinificacion.tranquilizacion.fin} onChange={(iso) => handleChange(iso, 'tranquilizacion', 'fin')} className="input" placeholder="Fin Fermentación Primaria"  />
</div>
</div>
<div className="column long">
<label className="input-label sticky-label">Guarda</label>
<div className="input-group">
<label className='date-label'>Fecha de inicio</label>
<FechaDateInput name="guarda_inicio" value={formData.vinificacion.guarda.inicio} onChange={(iso) => handleChange(iso, 'guarda', 'inicio')} className="input" placeholder="Inicio Fermentación Primaria"  />
</div>
<div className="input-group number">
<input type="number" name="temperatura_controlada" value={formData.vinificacion.guarda.temperatura} onChange={(e) => handleNumberChange(e, "guarda", 'temperatura')} className="input" step="0.1" placeholder="Temperatura"  />
<span className="unit">°C</span></div>
<div className="input-group number">
<input type="number" name="humedad_controlada" value={formData.vinificacion.guarda.humedad} onChange={(e) => handleNumberChange(e, "guarda", 'humedad')} className="input" placeholder="Humedad"  />
<span className="unit">%</span></div>
<div className="input-group number">
<input type="number" name="graduacion_alcoholica" value={formData.vinificacion.guarda.graduacion_alcoholica} onChange={(e) => handleNumberChange(e, "guarda", 'graduacion_alcoholica')} className="input" step="0.1" placeholder="Graduación alcohólica"  />
<span className="unit">%</span></div>
<div className="input-group number">
<input type="number" name="nivel_acido" value={formData.vinificacion.guarda.nivel_acidez} onChange={(e) => handleNumberChange(e, "guarda", 'nivel_acidez')} className="input" step="0.1" placeholder="Nivel de acidéz"  />
<span className="unit">g/L</span></div>
<div className="input-group number">
<input type="number" name="nivel_azucar" value={formData.vinificacion.guarda.nivel_azucar} onChange={(e) => handleNumberChange(e, "guarda", 'nivel_azucar')} className="input" step="0.1" placeholder="Nivel de azúcar"  />
<span className="unit">° Brix</span></div>
<div className="input-group number">
<input type="number" name="nivel_ph" value={formData.vinificacion.guarda.nivel_ph} onChange={(e) => handleNumberChange(e, "guarda", 'nivel_ph')} className="input" step="0.1" placeholder="Nivel de pH"  />
<span className="unit">pH</span></div>
<div className="input-group">
<Listbox
value={formData.vinificacion.guarda.recipiente_utilizado}
onChange={(value) => {
handleChange(value, 'guarda', 'recipiente_utilizado');
if (value !== 'Barrica otro') setOtroRecipiente(''); // limpiar si cambia a otra opción
}}
>
{({ open }) => (
<>
<ListboxButton
className={`custom-listbox-button ${open ? 'open' : ''} ${
formData.vinificacion.tranquilizacion.recipiente_utilizado ? 'selected' : 'placeholder'
}`}
>
{formData.vinificacion.tranquilizacion.recipiente_utilizado || "Recipiente utilizado"}
<span className="custom-arrow-container"><span className="custom-arrow"></span></span>
</ListboxButton>
<ListboxOptions className="custom-listbox-options">
{tiposDeRecipienteFermentacion.map((recipiente) => (
<ListboxOption
key={recipiente}
value={recipiente}
className="custom-listbox-option"
>
{recipiente}
</ListboxOption>
))}
</ListboxOptions>
</>
)}
</Listbox>
</div>

{formData.vinificacion.guarda.recipiente_utilizado === "Barrica otro" && (
<div className="input-group">
<input
type="text"
placeholder="Especificar tipo de barrica"
value={otroRecipiente}
onChange={(e) => setOtroRecipiente(e.target.value)}
className="input"
/>
</div>
)}
{formData.vinificacion.guarda.recipiente_utilizado?.toLowerCase().startsWith("barrica") && (
<>
<div className="input-group">
<Listbox
value={formData.vinificacion.guarda.recipiente_uso}
onChange={(value) => handleChange(value, 'guarda', 'recipiente_uso')}
>
{({ open }) => (
<>
<ListboxButton className={`custom-listbox-button ${open ? 'open' : ''} ${formData.vinificacion.guarda.recipiente_uso ? 'selected' : 'placeholder'}`}>
{formData.vinificacion.guarda.recipiente_uso || "Uso del recipiente"}
<span className="custom-arrow-container"><span className="custom-arrow"></span></span>
</ListboxButton>
<ListboxOptions className="custom-listbox-options">
{opcionesRecipienteUso.map((opcion) => (
<ListboxOption key={opcion} value={opcion} className="custom-listbox-option">
{opcion}
</ListboxOption>
))}
</ListboxOptions>
</>
)}
</Listbox>
</div>

<div className="input-group">
<Listbox
value={formData.vinificacion.guarda.recipiente_tostado}
onChange={(value) => handleChange(value, 'guarda', 'recipiente_tostado')}
>
{({ open }) => (
<>
<ListboxButton className={`custom-listbox-button ${open ? 'open' : ''} ${formData.vinificacion.guarda.recipiente_tostado ? 'selected' : 'placeholder'}`}>
{formData.vinificacion.guarda.recipiente_tostado || "Tostado de recipiente"}
<span className="custom-arrow-container"><span className="custom-arrow"></span></span>
</ListboxButton>
<ListboxOptions className="custom-listbox-options">
{opcionesRecipienteTostado.map((opcion) => (
<ListboxOption key={opcion} value={opcion} className="custom-listbox-option">
{opcion}
</ListboxOption>
))}
</ListboxOptions>
</>
)}
</Listbox>
</div>
</>
)}
<div className="input-group">
<label className='date-label'>Fecha de finalización</label>
<FechaDateInput name="guarda_fin" value={formData.vinificacion.guarda.fin} onChange={(iso) => handleChange(iso, 'guarda', 'fin')} className="input" placeholder="Fin Fermentación Primaria"  />
</div>
<div className="button-container" style={{marginTop:'20px'}}>
<div className="input-group number">
<input
type="number"
name="precioUnidad"
value={formData.precioUnidad ?? ''}
onChange={handleNumberChange}
className="input"
step="0.01"
placeholder="Precio por unidad"
style={{ marginBottom: '0px' }}
/>
<span className="unit">$</span>
</div>
<div className="input-group">
<input
type="text"
name="profesional_responsable"
value={formData.profesional_responsable}
onChange={handleChange}
className="input"
placeholder="Profesional responsable"
/>
</div>
<hr style={{ border: "0", borderTop: "1px solid #eaeef5", margin: "0px 0 0px" }} />
<button
type="submit"
className={`button ${message?.type === 'success' ? 'success' : ''}`}
disabled={isLoading || !esFormularioValido()}
>
<span className="button-text">
{message?.type === 'success' ? 'Guardado' : isLoading ? 'Creando...' : 'Crear partida'}
</span>
{isLoading && (
<span
className="progress-bar"
style={{ width: `${progress}%` }}
></span>
)}
</button>
</div>
</div>
</div>
</form>
{message && (
<div className={`message ${message.type}`}>
{message.text}
</div>
)}
</div>
);
};
export default VinificacionForm;